export function initSideNav() {
	document.querySelectorAll('.diakon-side-nav__toggle').forEach((btn) => {
		btn.addEventListener('click', () => {
			const expanded = btn.getAttribute('aria-expanded') === 'true';
			const subList = document.getElementById(
				btn.getAttribute('aria-controls')
			);
			const item = btn.closest('.diakon-side-nav__item');
			if (!subList || !item) {
				return;
			}

			const nowExpanded = !expanded;
			btn.setAttribute('aria-expanded', String(nowExpanded));
			subList.hidden = !nowExpanded;
			item.classList.toggle('is-open', nowExpanded);

			const srText = btn.querySelector('.diakon-side-nav__sr-only');
			if (srText) {
				srText.textContent = nowExpanded
					? 'Sulje alasivut'
					: 'Avaa alasivut';
			}
		});
	});
}
